<template>
  <div class="bodycontent">
    <div class="page_title">
      打印机设置
    </div>
    <div class="page_form">
      <el-form :model="formData" size="small" label-width="120px">
        <el-form-item label="打印机名称">
          <!-- <el-select v-model="formData.type" style="width:310px">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.name" style="width:310px"></el-input>
        </el-form-item>
        <el-form-item label="绑定打印机">
          <el-input class="input_box" v-model="formData.device_no" placeholder="设备终端号"></el-input>
          <el-input class="input_box" v-model="formData.device_key" placeholder="设备key值"></el-input>
          <div class="form_info_text">请填写打印机设备终端号和key值</div>
        </el-form-item>
        <el-form-item label="是否打印二维码">
          <el-checkbox v-model="formData.is_code">打印二维码</el-checkbox>
        </el-form-item>
        <el-form-item label="小票打印张数">
          每个付款单自动打印
          <el-input class="input_box_small" v-model="formData.times" size="small"></el-input>
          张
        </el-form-item>
        <el-form-item label="是否开启打印">
          <el-checkbox v-model="formData.is_open">开启打印</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div class="save_button">
      <el-button size="small" type="primary" @click="save()">确定</el-button>
    </div>
  </div>
</template>
<script>
import { getPrinter, setPrinter } from "@/api/set";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      formData:{}
    }
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      getPrinter(data).then(res => {
        if(res.code == 200){
          console.log(res.data)
          // this.formData = {
          //   id: res.data.id,
          //   name: res.data.name,
          //   device_no: res.data.device_no,
          //   device_key: res.data.device_key,
          //   times: res.data.times,
          //   code: res.data.is_code == 1? true:false,
          //   open: res.data.is_open == 1? true:false
          // }
          this.formData = Object.assign({},res.data);
          this.formData.is_code = this.formData.is_code == 1? true:false;
          this.formData.is_open = this.formData.is_open == 1? true:false;
          delete this.formData.app_id;
          delete this.formData.create_time;
        }else{
          this.$message(res.msg);
        }
      })
    },
    save(){
      var data = Object.assign({},this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      data.is_code = data.is_code? 1:0;
      data.is_open = data.is_open? 1:0;
      console.log(data);
      // return false;
      setPrinter(data).then(res => {
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "保存成功"
          })
          this.init();
        }else{
          this.$message(res.msg);
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding:0 18px;
  .page_title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form{
    padding-top: 30px;
    .input_box{
      width: 150px;
      margin-right: 10px;
    }
    .input_box_small{
      width: 50px;
    }
    .form_info_text{
      color: #aaa;
    }
  }
  .save_button{
    margin-top: 25px;
    padding-left:100px;
    margin-bottom: 50px;
  }
}
</style>